// test1056
(1056 && 0);
